/**
 * @file Pipeline ORDONNE des systemes executes a chaque tic (l'ordre fait partie du contrat de determinisme).
 */
import { CatSystem } from './CatSystem';
import { ControlSystem } from './ControlSystem';
import { EnemyAiSystem, MoverSystem } from './EnemySystems';
import { ProjectileSystem } from './ProjectileSystem';
import { ModeSystem, TimersSystem, VisualStatusSystem } from './StatusSystems';
import type { System } from './System';
import { WeaponSystem } from './WeaponSystem';

/**
 * 1. mode        : machine a etats (spawns, chrono, issue)
 * 2. enemyAi     : decisions des monstres/boss (ancres de deplacement)
 * 3. movers      : deplacement des cibles + mise a jour de la grille
 * 4. cats        : IA des chats, ciblage, visee
 * 5. control     : deplacement du chef (manuel / AutoMove)
 * 6. weapons     : tirs (creation de projectiles / faisceaux)
 * 7. projectiles : deplacement, collisions, impacts, explosions
 * 8. visualStatus: flashs, animations de mort -> destruction
 * 9. timers      : buffs, tickets, missions, auto-upgrade (tourne aussi en pause)
 * Puis Simulation appelle world.flush().
 */
export const SYSTEM_PIPELINE: readonly System[] = [
  ModeSystem,
  EnemyAiSystem,
  MoverSystem,
  CatSystem,
  ControlSystem,
  WeaponSystem,
  ProjectileSystem,
  VisualStatusSystem,
  TimersSystem,
];
